<template>
  <div>
    <iceverg-sidebar></iceverg-sidebar>
    <v-main>
      <iceverg-header></iceverg-header>
      <transition name="router-anim" :enter-active-class="`animated pulse`">
        <router-view :class="[{'mt-12': isXs}]" class="mb-10"></router-view>
      </transition>

    </v-main>

    <v-footer inset absolute class="small justify-center bg-default">
      <span class="px-3">Iceverg &copy; {{ year }}</span>
      <v-divider vertical></v-divider>
      <router-link to="/legal" class="px-3 b-" target="_blank">Legal</router-link>
      <v-divider vertical></v-divider>
      <router-link to="/privacy" class="px-3" target="_blank">Privacy</router-link>
    </v-footer>
  </div>
</template>

<script>
  import IcevergHeader from "../components/Header/icevergHeader";
  import {getBreakpoint} from "../helpers/helpers";
  import IcevergSidebar from "../components/Sidebar/icevergSidebar";

  export default {
    name: "IcevergPanel.vue",
    components: {IcevergSidebar, IcevergHeader},
    computed: {
      isXs() {
        return getBreakpoint(this) === 'xs';
      },
      year(){
        return (new Date()).getFullYear()
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/IcevergPanel.vue